import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DeleteDialogUI, FileTabUI, FormLabelUI, InputUI, TabsUI } from '../Interface';

const DescriptionPanel = ({ editedTask, handleChange }) => {
  return (
    <div>
      <div className="col-span-full relative">
        <InputUI
          type="text"
          className="resize-none"
          fullWidth
          label={<FormLabelUI text="Megjegyzés" />}
          variant="standard"
          value={editedTask?.description}
          onChange={(e) => handleChange('description', e.target.value)}
          multiline
          rows={3}
        />
      </div>
    </div>
  );
};

const TaskListTodoTabs = (props) => {
  const { editedTask, setEditedTask } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      file.isNew = true;
      return file;
    });

    setEditedTask((prev) => {
      const existingAttachments = Array.isArray(prev.attachment) ? prev.attachment : [];
      return {
        ...prev,
        attachment: [...existingAttachments, ...filesWithId],
      };
    });
  };

  const tabs = [
    {
      id: 1,
      name: 'Megjegyzés',
      content: <DescriptionPanel {...props} />,
    },

    {
      id: 2,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={editedTask?.attachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          handleUpload={handleUpload}
        />
      ),
    },
  ];

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    setEditedTask((prev) => ({
      ...prev,
      attachment: (prev.attachment || []).filter((attachment) => attachment.id !== fileToDelete.id),
    }));

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div>
      <div className="px-2">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default TaskListTodoTabs;
